<template>
  <BootstrapDropdown>
    <template #toggle>
      <IconButton
        id="help-menu-btn"
        icon-name="material-symbols:help-outline"
        size="lg"
        data-bs-toggle="dropdown"
        data-bs-auto-close="outside"
        :badge="unreadTours > 0 ? unreadTours.toString() : ''"
      />
    </template>
    <template #items>
      <SettingsDialogListGroup :list="list" @update:model-value="handleFeedbackOpen">
        <section v-if="availableTours?.length === 0" class="text-muted text-center">
          <Icon icon="material-symbols:tour-outline" class="mb-1" />
          <p>No tours available on this page</p>
        </section>
        <BootstrapButton
          v-for="tour in availableTours"
          :key="tour.key"
          :name="tour.name"
          variant="ghost"
          size="sm"
          :aria-label="`Start ${tour.name} tour`"
          @click="handleStart(tour.key)"
        >
          <span class="text-nowrap">{{ tour.name }}</span>
          <Icon
            v-if="tour.completed"
            icon="material-symbols:check-circle-outline"
            class="text-success ms-2 me-0"
          />
        </BootstrapButton>
      </SettingsDialogListGroup>
    </template>
  </BootstrapDropdown>
</template>
<script setup lang="ts">
import {useGuidedTours} from '@/composables/guidedTours/useGuidedTours';
import {feedbackOpenKey} from '@/components/shared/custom/FeedbackSlideIn/injectionKeys';

const handleFeedbackOpen = inject(feedbackOpenKey);
const list: Map<string | undefined, [string, string][]> = new Map([['Guides', []]]);

const {startTour, availableToursForRegisteredComponents} = useGuidedTours();

const availableTours = availableToursForRegisteredComponents;

const unreadTours = computed(
  () => availableTours.value?.filter((tour: {completed: any}) => !tour.completed).length,
);

function handleStart(key: string) {
  const btn = document.getElementById('help-menu-btn');
  if (btn?.classList.contains('show')) {
    (btn as HTMLElement).click();
  }
  startTour(key);
}
</script>
<style lang="scss" scoped>
:deep(.dropdown-menu) {
  padding: 1rem;
}

section > p {
  margin: 0;
  font-size: 0.75rem;
}
</style>
<style lang="scss">
.driver-popover.guided-tour-popover {
  background-color: var(--bs-body-bg) !important;
  color: var(--bs-body-color) !important;
  border-radius: 1rem !important;

  .driver-popover-arrow-side-left.driver-popover-arrow {
    border-left-color: var(--bs-body-bg) !important;
  }

  .driver-popover-arrow-side-right.driver-popover-arrow {
    border-right-color: var(--bs-body-bg) !important;
  }

  .driver-popover-arrow-side-top.driver-popover-arrow {
    border-top-color: var(--bs-body-bg) !important;
  }

  .driver-popover-arrow-side-bottom.driver-popover-arrow {
    border-bottom-color: var(--bs-body-bg) !important;
  }

  .driver-popover-close-btn {
    color: var(--bs-body-color) !important;
  }
}
</style>
